const Logo = () => <img src="/images/goodcrowd.svg" height="30px" alt="GoodCrowd.org logo" className="ui image logo" />

export default Logo
